export default __webpack_public_path__ + "static/media/agentTrav.ceb56090.png";